import { render, staticRenderFns } from "./questionTypeTime.vue?vue&type=template&id=f0b6c05c&scoped=true&"
import script from "./questionTypeTime.vue?vue&type=script&lang=js&"
export * from "./questionTypeTime.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeTime.vue?vue&type=style&index=0&id=f0b6c05c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b6c05c",
  null
  
)

export default component.exports